import React, { useState, useEffect } from "react";
import { message } from "antd";
import axios from "axios";
import {
  FaShare,
  FaTimes,
  FaFileAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaPaperPlane,
  FaSpinner,
  FaEnvelope,
  FaComment,
} from "react-icons/fa";

function TimesheetSend({ isOpen, onClose, errorDates, userallroster }) {
  const userStr = JSON.parse(localStorage.getItem("users"));
  const apiurl = "https://jlmining.app/api/coverageTimeSheet/";
  const [coverageTimesheet, setCoverageTimesheet] = useState([]);
  const [loading, setLoading] = useState(true);
  const [weekdetails, setweekdetails] = useState([]);
  const [activeindex, setactiveindex] = useState(null);
  const [spinners, setspinners] = useState(false);
  const [formDataa, setFormDataa] = useState({});
  const [clientlist, setclientlist] = useState([]);
  const [openTimesheet, setopenTimesheet] = useState(false);
  useEffect(() => {
    const activeRosterRow = userallroster.find(
      (r) => r.active_roster === "Yes"
    );
    if (userallroster.length > 0) {
      getAllclientRoster(activeRosterRow.id);
    }
    if (isOpen) {
      // getCoverageTimeSheet();
    }
  }, [isOpen]);
  const getAllclientRoster = (rosterId) => {
    let formData = {
      rosterId: rosterId,
    };
    axios
      .post(apiurl + "getAllclientRoster", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const alldata = res.data.results;

        setclientlist(alldata);
      })
      .catch((err) => {
        console.error("Error fetching timesheet data:", err);
        // setLoading(false);
      });
  };
  const getCoverageTimeSheet = (clientid, location_id) => {
    setLoading(true);
    const activeRoster = userallroster.filter((r) => r.active_roster === "Yes");
    const activeRosterTypes = activeRoster.map((r) => r.type);

    let formData = {
      user_id: userStr[0].id,
      rostertype: activeRosterTypes[0],
      client_id: clientid,
      roster_id: activeRoster[0].id,
      location_id: location_id,
    };

    axios
      .post(apiurl + "getCoverageTimeSheet", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const alldata = res.data.arr;
        setCoverageTimesheet(alldata);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching timesheet data:", err);
        setLoading(false);
      });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getuserweeklydata = (
    index,
    start,
    end,
    user_id,
    rosterid,
    locationid,
    client_id
  ) => {
    let data = {
      start: start,
      end: end,
      user_id: user_id,
      rosterid: rosterid,
      locationid: locationid,
      client_id: client_id,
    };

    setactiveindex(index);
    axios
      .post(apiurl + "getWeeklyDataTimesheet", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          setweekdetails(res.data.data);
        }
      })
      .catch((err) => {});
  };

  const sendShare = (
    index,
    start,
    end,
    user_id,
    roster_id,
    client_id,
    location_id
  ) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = formDataa[index]?.email?.trim() || "";
    const messageText = formDataa[index]?.message?.trim() || "";

    const emailEmpty = email === "";
    const emailInvalid = !emailEmpty && !emailRegex.test(email);
    const messageEmpty = messageText === "";

    if (emailEmpty || emailInvalid || messageEmpty) {
      return;
    }
    const activeRoster = userallroster.filter((r) => r.active_roster === "Yes");
    const activeRosterTypes = activeRoster.map((r) => r.type);
    let senddata = {
      email: email,
      message: messageText,
      start_date: start,
      end_date: end,
      user_id: user_id,
      roster_id: roster_id,
      client_id: client_id,
      location_id: location_id,
      rostertype: activeRosterTypes[0],
    };

    setspinners(true);
    axios
      .post(apiurl + "sendtimeSheet", senddata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // Handle success
        message.success("Email successfully send");
        setspinners(false);
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      })
      .catch((err) => {
        setspinners(false);
      });
  };

  const handleEmailInput = (index, value) => {
    setFormDataa((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        email: value,
      },
    }));
  };

  const handleMessageInput = (index, value) => {
    setFormDataa((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        message: value,
      },
    }));
  };
  const handlegetClient = (e) => {
    const selectedClientId = e.target.value; // this is the client_id
    console.log(selectedClientId);
    setweekdetails([]);
    const { client_id, location_id } = JSON.parse(e.target.value);
    if (selectedClientId !== "") {
      setopenTimesheet(true);
      getCoverageTimeSheet(client_id, location_id);
    } else {
      setopenTimesheet(false);
    }

    // You can now use this ID to fetch data or update state
    // For example:
    // setSelectedClientId(selectedClientId);
  };
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-title">
            <FaFileAlt className="title-icon" />
            <h2>Share Timesheet</h2>
          </div>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Message Alert */}

        {/* Timesheet List */}
        <div className="timesheet-content">
          <label className="mb-2">Client</label>
          <select className="form-control mb-4" onChange={handlegetClient}>
            <option value="">--Select Client--</option>
            {clientlist.map((client) => (
              <option
                key={client.client_id}
                value={JSON.stringify({
                  client_id: client.client_id,
                  location_id: client.location_id,
                })}
              >
                {client.client_name}
              </option>
            ))}
          </select>
          {openTimesheet && (
            <h3 className="timesheet-subtitle">Available Timesheets</h3>
          )}
          {openTimesheet && (
            <>
              {loading ? (
                <div className="loading-state">
                  <div className="loading-spinner"></div>
                  <p>Loading timesheets...</p>
                </div>
              ) : coverageTimesheet && coverageTimesheet.length > 0 ? (
                <div className="timesheet-list">
                  {coverageTimesheet.map((item, index) => (
                    <div key={index} className="timesheet-item-container">
                      <div
                        className={`timesheet-item ${
                          activeindex === index ? "active" : ""
                        }`}
                        onClick={() =>
                          getuserweeklydata(
                            index,
                            item.start,
                            item.end,
                            item.user_id,
                            item.roster_id,
                            item.location_id,
                            item.client_id
                          )
                        }
                      >
                        <div className="timesheet-info">
                          <span className="timesheet-dates">
                            {formatDate(item.start)} - {formatDate(item.end)}
                          </span>
                          <div className="timesheet-status">
                            <span className="status-badge">Ready to share</span>
                          </div>
                        </div>
                        <button
                          className="share-button"
                          type="button"
                          title="Share"
                          onClick={(e) => {
                            e.stopPropagation();
                            setactiveindex(
                              activeindex === index ? null : index
                            );
                          }}
                        >
                          <FaShare />
                        </button>
                      </div>

                      {activeindex === index && (
                        <div className="share-panel">
                          <div className="share-panel-header">
                            <h4>Share this timesheet</h4>
                            <button
                              type="button"
                              className="close-panel"
                              onClick={() => setactiveindex(null)}
                            >
                              <FaTimes />
                            </button>
                          </div>
                          {weekdetails.length > 0 ? (
                            <>
                              <div className="form-group">
                                <label className="input-label">
                                  <FaEnvelope className="input-icon" />
                                  Recipient Email
                                </label>
                                <input
                                  type="email"
                                  className="form-input"
                                  placeholder="Enter email address"
                                  value={formDataa[index]?.email || ""}
                                  onChange={(e) =>
                                    handleEmailInput(index, e.target.value)
                                  }
                                />
                              </div>

                              <div className="form-group">
                                <label className="input-label">
                                  <FaComment className="input-icon" />
                                  Message (Optional)
                                </label>
                                <textarea
                                  className="form-textarea"
                                  placeholder="Add a message to accompany the timesheet"
                                  rows={3}
                                  value={formDataa[index]?.message || ""}
                                  onChange={(e) =>
                                    handleMessageInput(index, e.target.value)
                                  }
                                />
                              </div>

                              <div className="form-actions">
                                <button
                                  className="btn-secondary"
                                  onClick={() => setactiveindex(null)}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn-primary"
                                  onClick={() =>
                                    sendShare(
                                      index,
                                      item.start,
                                      item.end,
                                      item.user_id,
                                      item.roster_id,
                                      item.client_id,
                                      item.location_id
                                    )
                                  }
                                  disabled={spinners}
                                >
                                  {spinners ? (
                                    <>
                                      <FaSpinner className="spinner" />
                                      Sending...
                                    </>
                                  ) : (
                                    <>
                                      <FaPaperPlane />
                                      Send Timesheet
                                    </>
                                  )}
                                </button>
                              </div>
                            </>
                          ) : (
                            <p>No records available to share this timesheet.</p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <FaFileAlt className="empty-icon" />
                  <p>No timesheets available</p>
                </div>
              )}
            </>
          )}
        </div>

        <style jsx>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1300;
            padding: 20px;
          }

          .modal-container {
            position: relative;
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
              0 10px 10px -5px rgba(0, 0, 0, 0.04);
            width: 100%;
            max-width: 700px;
            max-height: 90vh;
            overflow: auto;
            display: flex;
            flex-direction: column;
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px;
            border-bottom: 1px solid #e5e7eb;
            background: #f9fafb;
            border-radius: 12px 12px 0 0;
          }

          .modal-title {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .modal-title h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 600;
            color: #1f2937;
          }

          .title-icon {
            font-size: 24px;
            color: #3b82f6;
          }

          .close-button {
            background: none;
            border: none;
            font-size: 18px;
            cursor: pointer;
            color: #6b7280;
            padding: 8px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
          }

          .close-button:hover {
            background-color: #f3f4f6;
            color: #374151;
          }

          .alert-box {
            border-radius: 8px;
            padding: 16px;
            margin: 0 24px;
            margin-top: 16px;
          }

          .alert-box.error {
            background-color: #fef2f2;
            border: 1px solid #fecaca;
          }

          .alert-box.success {
            background-color: #f0fdf4;
            border: 1px solid #bbf7d0;
          }

          .alert-content {
            display: flex;
            align-items: flex-start;
            gap: 12px;
          }

          .alert-icon {
            font-size: 20px;
            margin-top: 2px;
            flex-shrink: 0;
          }

          .alert-icon.error {
            color: #dc2626;
          }

          .alert-icon.success {
            color: #059669;
          }

          .alert-content p {
            margin: 0;
            color: inherit;
            line-height: 1.5;
            font-weight: 500;
          }

          .timesheet-content {
            padding: 24px;
            flex: 1;
            overflow-y: auto;
          }

          .timesheet-subtitle {
            margin: 0 0 20px 0;
            font-size: 18px;
            font-weight: 600;
            color: #374151;
          }

          .timesheet-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .timesheet-item-container {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .timesheet-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .timesheet-item:hover {
            border-color: #3b82f6;
            background-color: #f8fafc;
          }

          .timesheet-item.active {
            border-color: #3b82f6;
            background-color: #eff6ff;
          }

          .timesheet-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .timesheet-dates {
            font-weight: 500;
            color: #1f2937;
          }

          .timesheet-status {
            display: flex;
            align-items: center;
          }

          .status-badge {
            font-size: 12px;
            padding: 4px 8px;
            background-color: #10b981;
            color: white;
            border-radius: 4px;
          }

          .share-button {
            background: none;
            border: none;
            font-size: 16px;
            cursor: pointer;
            color: #6b7280;
            padding: 8px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
          }

          .share-button:hover {
            color: #3b82f6;
            background-color: #eff6ff;
          }

          .share-panel {
            padding: 20px;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            background-color: #f9fafb;
            animation: slideDown 0.3s ease;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .share-panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
          }

          .share-panel-header h4 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #374151;
          }

          .close-panel {
            background: none;
            border: none;
            font-size: 14px;
            cursor: pointer;
            color: #6b7280;
            padding: 4px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .close-panel:hover {
            background-color: #e5e7eb;
          }

          .form-group {
            margin-bottom: 16px;
          }

          .input-label {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;
            font-weight: 500;
            color: #374151;
            font-size: 14px;
          }

          .input-icon {
            font-size: 14px;
            color: #6b7280;
          }

          .form-input,
          .form-textarea {
            width: 100%;
            padding: 10px 12px;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            font-size: 14px;
            transition: all 0.2s;
            font-family: inherit;
          }

          .form-input:focus,
          .form-textarea:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .form-textarea {
            resize: vertical;
            min-height: 80px;
          }

          .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 16px;
          }

          .btn-primary,
          .btn-secondary {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border: none;
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn-primary {
            background-color: #3b82f6;
            color: white;
          }

          .btn-primary:hover:not(:disabled) {
            background-color: #2563eb;
          }

          .btn-primary:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }

          .btn-secondary {
            background-color: #f3f4f6;
            color: #374151;
            border: 1px solid #d1d5db;
          }

          .btn-secondary:hover {
            background-color: #e5e7eb;
          }

          .spinner {
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .loading-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
            gap: 16px;
          }

          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #e5e7eb;
            border-top: 4px solid #3b82f6;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          .empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
            gap: 16px;
            color: #6b7280;
          }

          .empty-icon {
            font-size: 48px;
            opacity: 0.5;
          }

          @media (max-width: 640px) {
            .modal-overlay {
              padding: 10px;
            }

            .modal-header,
            .timesheet-content {
              padding: 16px;
            }

            .alert-box {
              margin: 0 16px;
              margin-top: 12px;
            }

            .form-actions {
              flex-direction: column;
            }

            .btn-primary,
            .btn-secondary {
              justify-content: center;
            }
          }
        `}</style>
      </div>
    </div>
  );
}

export default TimesheetSend;
